import React from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api, { errMessage } from "@/lib/api";

const LABELS = { admin: "Admin · excluded", manual: "Test (marked)", auto: "Test (auto)" };

export function TestFlagControl({ user, onChange }) {
  if (user.role === "admin") return <span className="text-xs text-slate-400" data-testid={`test-flag-${user.id}`}>{LABELS.admin}</span>;
  const value = user.is_test === true ? "test" : user.is_test === false ? "genuine" : "auto";
  const set = async (v) => {
    try {
      await api.post(`/admin/users/${user.id}/test-flag`, { is_test: v === "test" ? true : v === "genuine" ? false : null });
      toast.success("Analytics classification updated.");
      onChange();
    } catch (e) { toast.error(errMessage(e)); }
  };
  return (
    <Select value={value} onValueChange={set}>
      <SelectTrigger className="h-8 w-[118px] px-2 text-xs" data-testid={`test-flag-${user.id}`}>
        <SelectValue>{user.test_reason ? LABELS[user.test_reason] : "Genuine"}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="auto" data-testid={`test-flag-auto-${user.id}`}>Automatic</SelectItem>
        <SelectItem value="test" data-testid={`test-flag-test-${user.id}`}>Mark as test</SelectItem>
        <SelectItem value="genuine" data-testid={`test-flag-genuine-${user.id}`}>Mark as genuine</SelectItem>
      </SelectContent>
    </Select>
  );
}
